<template>
<div></div>
</template>

<script>
export default {
  name: 'PageNotFound',
  mounted () {
    this.$store.dispatch('flash/showMessage', {message: 'Page not found', type: 'error'})
    this.$router.replace({'name': 'discover'})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/PageNotFound.vue